export class Token {
  accessToken: string;
  expiresIn: number;
  tokenType: string;
  issued: Date;
  expires: Date;
  nome: string;
  email: string;
  bloqueio: string;
  seguranca: string;
  origem: number;
  tipoSaas: number;
  empresa: string;
  empresaLogo: string;
}
